import React from 'react';
import './RealEstatePage.css';

function RealEstatePageEn() {
  return (
    <div className="page realestate-page">
      <section className="realestate-hero">
        <div className="realestate-hero-content">
          <h1>Real Estate</h1>
        </div>
      </section>

      <section className="realestate-content">
        <div className="content-container">
          <div className="intro-text">
            <h2 className="intro-title">Specialists in Real Estate Brokerage and Investment</h2>
            <p>
              TABIA Real Estate is the TABIA Group company specialized in the search, analysis and 
              brokerage of real estate products, both in purchase and sale operations as well as 
              leasing, with a main focus on Spain and a growing presence in other European markets.
            </p>
            <p>
              We serve buyers and sellers, as well as landlords and tenants, 
              accompanying them in identifying the most suitable opportunity at any given time, always based on 
              their objectives and market conditions in terms of location, asset type, 
              price, profitability and risk profile.
            </p>
            <p>
              Our approach is based on deep knowledge of the real estate market, combined with a 
              rigorous analysis methodology and a strategic vision that allows us to anticipate opportunities 
              and structure operations efficiently and securely.
            </p>
          </div>

          <div className="section-block">
            <h2>Operational Efficiency and Results-Oriented Approach</h2>
            <p>
              TABIA Real Estate's activity is focused on optimizing time and resources, 
              ensuring agile processes and informed decision-making. Our structure allows us to 
              reduce friction in brokerage, filter opportunities precisely and concentrate 
              efforts exclusively on those operations that provide real value to our clients.
            </p>
            <p>
              This efficient approach is especially relevant for families and clients in asset 
              management, as it allows for natural integration of real estate brokerage within a 
              global asset management and rotation strategy, aligned with defined asset objectives.
            </p>
          </div>

          <div className="section-block">
            <h2>Strategic Network of Contacts</h2>
            <p>
              TABIA Real Estate relies on an extensive and consolidated network of contacts, developed 
              organically over the years, which includes owners, investors, family offices, developers, 
              operators, investment funds, financial institutions and other industry professionals.
            </p>
            <p>
              This network not only allows us to access off-market opportunities, but 
              constitutes a key element to complement and reinforce the real estate asset management service 
              that TABIA provides to families and clients under management. Thanks to this, we can 
              offer comprehensive solutions ranging from opportunity identification to their 
              incorporation, rotation or divestment within previously structured portfolios.
            </p>
          </div>

          <div className="section-block highlight">
            <h2>An Integrated Service within the TABIA Group</h2>
            <p>
              TABIA Real Estate acts in coordination with TABIA Management, which allows us to offer a 
              real estate service aligned with each client's global asset strategy. This integration 
              facilitates a transversal view of assets and the market, providing greater coherence, control and 
              long-term value generation.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default RealEstatePageEn;
